export const BROWSE_DESKTOP_MIN_WIDTH = 1024;
